<div
  class="store-finder-list-item__container"
  [ngClass]="{ '-active': this.isActive() }"
>
  <div class="store-finder-list-item__marker">
    <img
      alt="Marker icon"
      class="store-finder-list-item__marker__icon -desktop"
      [src]="
        isActive()
          ? '/assets/images/icons/google-maps/Greymarker_icon-small.svg'
          : store().isCramoPOS
            ? '/assets/images/icons/google-maps/Redmarker_icon.svg'
            : '/assets/images/icons/google-maps/Orangemarker_icon.svg'
      "
    />
    <img
      alt="Marker icon"
      class="store-finder-list-item__marker__icon -mobile"
      [src]="
        store().isCramoPOS
          ? '/assets/images/icons/google-maps/Redmarker_icon.svg'
          : '/assets/images/icons/google-maps/Orangemarker_icon.svg'
      "
    />

    <span class="store-finder-list-item__marker__index">{{
      listNumber()
    }}</span>
  </div>

  <div class="store-finder-list-item__details">
    <div class="store-finder-list-item__title-wrapper">
      <h5>{{ store().displayName }}</h5>
      @if (!isRegion()) {
        <div [attr.data-qa]="'store-distance'">
          {{ store().formattedDistance }}
        </div>
      }
    </div>

    @if (store().address) {
      <p class="store-finder-list-item__address">
        {{ store().address!.line1 }} {{ store().address!.line2 }}
        <br />
        {{ store().formattedAddress }}
      </p>
    }

    @if (store().address?.phone) {
      <a
        class="store-finder-list-item__phone"
        [href]="'tel:' + store().address!.phone | phoneFilter"
        >{{ 'storeFinder.storeDetails.tel' | transloco }} :
        {{ store().address!.phone }}</a
      >
    }

    <div class="store-finder-list-item__actions">
      @if (
        store().address?.region?.name &&
        store().displayNameSlug &&
        !store().isCramoPOS &&
        store().showDetailsButton
      ) {
        <a
          boelsAnchorButton
          [cmsRouterLink]="['branches', store().url]"
          [attr.data-dm]="
            {
              data_type: 'cta',
              item_name: 'branch-list btn-details',
            } | json
          "
          >{{ 'storeFinder.result.details' | transloco }}</a
        >
      }
      @if (store().isCramoPOS) {
        <a
          boelsAnchorButton
          target="_blank"
          href="https://www.cramo.com"
          [icon]="faExternalLinkAlt"
        >
          {{ 'storeFinder.result.cramoLabel' | transloco | uppercase }}
        </a>
      }
      <a
        class="btn btn-underline -directions"
        [href]="
          'https://www.google.com/maps/dir/Current+Location/' +
          store().geoPoint.latitude +
          ',' +
          store().geoPoint.longitude
        "
        target="_blank"
        rel="noopener"
        [attr.data-dm]="
          {
            data_type: 'cta',
            item_name: 'branch-list btn-route',
          } | json
        "
      >
        {{ 'storeFinder.storeDetails.getDirections' | transloco }}
      </a>
    </div>
  </div>
</div>
